import Board from "react-trello"
import ScrollableLane from "../Virtualized/ScrollableLane"
import { CardBoard } from "../Card"
import { LaneBoard } from "../Lane"
import { LoadingWithLabel } from "../../Loading"
import { applyFilterKanban } from "../../../core/utils/farmerFilter/filters"
import { useScope } from "../../../container/SelectProjectCompanyContainer"
import { useSelector } from "react-redux"

const Kanban = ({
  kanbanData,
  isCheckAll,
  selectedCardOnBoard,
  handleSelectedAllCardsOnBoard,
  handleNavigateToProfile,
  handleSelectedCardOnBoard,
  users,
  handleRemoveTag,
  onDragEnd,
  onDataChange,
  isInitialLoading,
  selectedsUsers,
  filter,
  tagsToFilter
}) => {

  const { scope } = useScope()
  const currentUser = useSelector((state) => state.app?.user?.user)

  return (
    <>
      {isInitialLoading ? (
        <div className="kanban-content-loading">
          <LoadingWithLabel
            labelLoading="Aguarde, estamos atualizando as informações do Kanban..."
            sizeSpinner="large"
            colorSpinner="primary"
          />
        </div>
      ) : (
        
        <Board
          laneDraggable={false}
          cardDraggable={false}
          components={{
            Card: (props) => {
              return (
                <CardBoard
                  handleSelectedCardOnBoard={handleSelectedCardOnBoard}
                  handleNavigateToProfile={handleNavigateToProfile}
                  selectedCardOnBoard={selectedCardOnBoard}
                  handleRemoveTag={handleRemoveTag}
                  currentUser={currentUser}
                  scope={scope}
                  {...props}
                />
              )
            },
            LaneHeader: (props) => {
              return (
                <LaneBoard
                  handleSelectedAllCardsOnBoard={handleSelectedAllCardsOnBoard}
                  isCheckAll={isCheckAll}
                  selectedsUsers={selectedsUsers}
                  users={users}
                  {...props}
                />
              )
            },
            ScrollableLane: ScrollableLane
          }}
          data={applyFilterKanban(kanbanData, filter, tagsToFilter)}
          onDataChange={onDataChange}
          handleDragEnd={onDragEnd}
        />
      )}
    </>
  )
}

export default Kanban